import React, { useEffect, useState } from 'react';
import { useDevGate } from '#GameFrontend/contexts/DevGateContext';
import { apiUrl } from '#GameFrontend/services/api';
import { Button } from '#GameFrontend/components/ui/button';

type DevAuthGateProps = {
	children: React.ReactNode;
};

const DevAuthGate: React.FC<DevAuthGateProps> = ({ children }) => {
	const devGate = useDevGate();
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const ssoError = params.get('sso_error');
		if (ssoError) {
			setError(decodeURIComponent(ssoError));
			window.history.replaceState({}, '', window.location.pathname);
		}
	}, []);

	if (devGate.loading) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-[#1a120b] text-white">
				<p className="text-lg opacity-80">Loading…</p>
			</div>
		);
	}

	if (!devGate.enabled || devGate.authenticated) {
		return <>{children}</>;
	}

	const handleLogin = () => {
		if (devGate.loginUrl) {
			window.location.href = apiUrl(devGate.loginUrl);
		}
	};

	return (
		<div className="min-h-screen flex items-center justify-center bg-[#1a120b] px-4">
			<div className="w-full max-w-md rounded-lg border border-[#5c4a32] bg-[#2a1f14]/90 p-8 text-center text-white shadow-xl">
				<h1 className="text-2xl font-semibold mb-2">Cavalcando Dev</h1>
				<p className="text-sm text-white/70 mb-6">
					Internal development environment. Sign in with your Cavalcando account to continue.
				</p>
				{error && (
					<p className="mb-4 rounded-md bg-red-900/40 border border-red-700 px-3 py-2 text-sm text-red-100">
						{error}
					</p>
				)}
				<Button type="button" className="w-full" onClick={handleLogin}>
					Sign in with Cavalcando SSO
				</Button>
				<p className="mt-6 text-xs text-white/50">
					After this gate, use the normal game login or registration to test in-game authentication.
				</p>
			</div>
		</div>
	);
};

export default DevAuthGate;
